import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminEventBuilder = lazy(() => import("@/pages/admin/AdminEventBuilder"));

export const Route = createFileRoute("/admin/event-builder")({
  component: AdminEventBuilder,
});
